import { render } from "./ComponentDetail.vue?vue&type=template&id=76e57e36&scoped=true"
import script from "./ComponentDetail.vue?vue&type=script&lang=js"
export * from "./ComponentDetail.vue?vue&type=script&lang=js"

import "./ComponentDetail.vue?vue&type=style&index=0&id=76e57e36&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76e57e36"]])

export default __exports__